import $ from 'jquery';
export default class GlobalProductAvailability {
    static STORAGE_KEY = 'products';
    static STORAGE_EXPIRES_KEY = 'products_expires_at';
    static STORAGE_TTL_MS = 15 * 60 * 1000;
    static init() {
        const url = document.body?.dataset?.globalAvailabilityUrl;
        if (!url) {
            return;
        }
        const expiresAt = Number(sessionStorage.getItem(this.STORAGE_EXPIRES_KEY));
        const hasValidCache = Number.isFinite(expiresAt) && expiresAt > Date.now();
        if (hasValidCache && sessionStorage.getItem(this.STORAGE_KEY)) {
            return;
        }
        $.ajax({
            method: 'GET',
            url,
        })
            .done(data => {
            if (!Array.isArray(data)) {
                return;
            }
            sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(data));
            sessionStorage.setItem(this.STORAGE_EXPIRES_KEY, String(Date.now() + this.STORAGE_TTL_MS));
        })
            .fail(() => { });
    }
}
